import React from "react";
import { View, StyleSheet } from 'react-native';
import Image from '../image/Image';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, ImageSizeTokens } from "@voltmoney/schema";
import Typography from "../typography/Typography";
import ThemeProvider from "@voltmoney/theme";
import Icon from "../icon/Icon";
const EmailSubtitle = ({ label, subLabel, iconUrl, iconName, isDarkMode }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    return (React.createElement(View, { style: [styles.container, {
                borderColor: colorMapping[ColorTokens.Secondary_20],
                backgroundColor: colorMapping[ColorTokens.Secondary_05]
            }] },
        React.createElement(View, { style: { padding: 12 } }, iconName
            ? React.createElement(View, { style: {
                    width: 40,
                    height: 40,
                    backgroundColor: '#FFFFFF',
                    borderRadius: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } },
                React.createElement(Icon, { name: iconName, color: ColorTokens.Secondary_100 })) : React.createElement(React.Fragment, null,
            React.createElement(Image, { uri: iconUrl, size: ImageSizeTokens.SIZE_40 }))),
        React.createElement(View, { style: { paddingVertical: 12, paddingRight: 12, flexShrink: 1 } },
            React.createElement(Typography, { label: label, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, lineHeight: 18 }),
            React.createElement(View, { style: { marginTop: 3 } },
                React.createElement(Typography, { label: subLabel, fontSize: FontSizeTokens.SM, fontWeight: '500', fontFamily: FontFamilyTokens.Inter, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, lineHeight: 20 })))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 12,
        borderWidth: 1,
    },
});
export default EmailSubtitle;
